import { Box, Button, Paper } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import SttError from './SttError';

export default function FullPageError() {
    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
                minHeight: '100vh',
                backgroundColor: 'background.default',
                p: 2,
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 3, sm: 5 },
                    maxWidth: 450,
                    width: '100%',
                    textAlign: 'center',
                    borderRadius: 3,
                    backgroundColor: 'background.paper',
                    border: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <SttError />
                <Box mt={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        startIcon={<RefreshIcon />}
                        onClick={() => {
                            window.location.assign(window.location.href);
                        }}
                        sx={{
                            px: 4,
                            py: 1.5,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        {t('generic.refresh')}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}
